module.exports = __webpack_public_path__ + "img/file-export.d9744141.svg";